<template>
	
  <DataView :value="extrasList" :layout="'grid'" :rows="12" 
                :paginator="extrasList.length>12?true:false" paginatorTemplate="PrevPageLink CurrentPageReport NextPageLink"
                currentPageReportTemplate="{currentPage} / {totalPages}"
    >

    <template #empty>
      <div class="p-m-4">{{$t('details.no_extras_found')}}</div>
    </template>

    <template #grid="slotProps">
      <div class="p-col-12 p-sm-6 nested-grid extras" >
        <div class="p-grid p-ai-center ">
          <div :class="['p-col',{'gray': !appliance.online}]">
            <span>{{slotProps.data.name}}</span>
          </div>
          <div :class="['p-col-fixed p-text-center',{'gray': !appliance.online}]">
            <span>{{slotProps.data.value}}</span> 
          </div>
        </div>
      </div>
    </template>

  </DataView>

</template>

<script>
import { mapGetters } from 'vuex';
import ApplianceService from '../../service/ApplianceService';

export default {
    components: {
    },
    props: {
      serialNumber: String
    },
    data() {
        return {
          msConverter: 1000, //Set it to 1000 if API response is in seconds or to 1 if milliseconds 
          extras: {
            "deviceTwin": [],
            "telemetry": [],
            "alarms": []
          },
          extrasList: []
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          unit: 'userdata/unit',
          deviceTwin: 'appliances/deviceTwin',
          isCelsius: 'userdata/isCelsius',
          is24hour: 'userdata/is24hour',
        }),
        appliance: function() {
            return this.$store.getters['appliances/appliance'](this.serialNumber);
        },
        model: function() {
          if(this.appliance.type=="ABBATTITORE" && this.appliance.gamma=='MF Next') {
            return "mf";
          }
          if(this.appliance.type=="ABBATTITORE" && this.appliance.gamma=='EF Next') {
            return "ef";
          }
          if(this.appliance.type=="ABBATTITORE" && this.appliance.gamma=='SF') {
            return "sf";
          }
          if(this.appliance.type=="ABBATTITORE" && this.appliance.gamma=='MYA') {
            return "mya";
          }
          if(this.appliance.type=="CONSERVATORE") {
            return "cp";
          }
          // if(this.appliance.type=="FERMALIEVITA" && this.deviceTwin.status && this.deviceTwin.status.function===0) {
          //   return "mp_0";
          // }
          // if(this.appliance.type=="FERMALIEVITA" && this.deviceTwin.status && this.deviceTwin.status.function===1) {
          //   return "mp_1";
          // }
          if(this.appliance.type=="FERMALIEVITA") {
            return "mp";
          }
          return "";
        }
    },
    watch: {
      appliance: 'buildExtrasList',
      deviceTwin: 'buildExtrasList',
      '$i18n.locale': 'buildExtrasList',
      model: 'getExtras'
    },
    created() {
      this.applianceService = new ApplianceService();
    },
    mounted() {
      this.getExtras();
    },
    methods: {
      getExtras() {
        this.extras = {
          "deviceTwin": [],
          "telemetry": [],
          "alarms": []
        };
        this.extrasList = [];
        if(this.model!="") {
          this.applianceService.getExtras(this.model)
            .then((extras) => {
              this.extras = extras;
              this.buildExtrasList();
            })
            .catch(error => {
              console.error("ERROR "+error);
              this.extras = {
                "deviceTwin": [],
                "telemetry": [],
                "alarms": []
              };
            });
        } else {
          this.buildExtrasList();
        }
      },
      buildExtrasList() {
        this.extrasList = [];

        this.extras.deviceTwin.forEach(function(extra) {
          this.extrasList.push(this.manageParam(extra, this.deviceTwin));
        }.bind(this));

        this.extras.telemetry.forEach(function(extra) {
          this.extrasList.push(this.manageParam(extra, this.appliance));
        }.bind(this));

        this.extras.alarms.forEach(function(extra) {
          let found = false;
          if(this.appliance.alarms!=null) {
            for(let i=0; i<this.appliance.alarms.length; i++) {
              let alarm = this.appliance.alarms[i];
              if(extra.name == alarm.name) {
                found = true;
                this.extrasList.push({
                  name: this.$t('extra.'+this.model+'.'+extra.name),
                  value: alarm.active ? "ON" : "OFF"
                });
                break;
              }
            }
          }
          if(!found) {
            this.extrasList.push({
              name: this.$t('extra.'+this.model+'.'+extra.name),
              value: "OFF"
            });
          }
        }.bind(this));
      },
      manageParam(extra, searchObject) {
        let path = extra.path.split(".");
        let value = null;
        try {
          value = this.searchValue(searchObject, path, 0);
        } catch(err) {
          console.debug("NOT FOUND "+extra.path);
          return {
            name: this.$t('extra.'+this.model+'.'+extra.path),
            value: value!=null? value : "N/A"
          };
        }

        if("decimal"===extra.type && !isNaN(value)) {

          if(extra.round) {
            value = this.$n(this.$functions.round(value / 10, extra.round), 'temperature');
          } else {
            value = this.$n(value / 10, 'temperature');
          }

        } else if("onoff"===extra.type && value!=null) {

          value = (value==1 || value==true || value=="true") ? "ON" : "OFF";

        } else if("timestamp"===extra.type && value!=null) {

          if(this.is24hour) {
            value = this.$d(this.$functions.utcDate(value,this.msConverter), "long");
          } else {
            value = this.$d(this.$functions.utcDate(value,this.msConverter), "long12");
          }

        }
        return {
          name: this.$t('extra.'+this.model+'.'+extra.path),
          value: value!=null? value : "N/A"
        };
      },
      searchValue(obj, path, index) {
        if(index > path.length-1) {
          return null;
        } 
        if(index == path.length-1) {
          return obj[path[index]];
        }
        return this.searchValue(obj[path[index]], path, index+1);
      }
    }
}
</script>

<style scoped>

.p-dataview {
  margin-top: -1rem;
}

</style>